import useNotificationEvents from '../notificationEvents/hooks/useNotificationEvents';

const useMfeEvents = () => {
  useNotificationEvents();
};

export default useMfeEvents;
